var cell_default = {
  "cell": "gA5A-",
  "header": "FWdHo",
  "selected": "_6XZyL",
  "editing": "wZp-u",
  "singleSelection": "Hr3jR",
  "hideLastBlock": "AmluO",
  "editorWrapper": "r9CB8",
  "viewerWrapper": "yb1Nf",
  "hideFirstBlock": "U91N3",
  "editor": "_8l5Z1",
  "edit": "r9Ezh",
  "view": "NLbaW",
  "editingToolbarWrapper": "FnNfe",
  "selectAll": "Jd912",
  "disableSelection": "_76xAJ"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
